import { Action } from '@ngrx/store';
import * as Actions from './form-entry-configurable-fields.actions';
import { IFormEntryConfigurableFieldsState } from './form-entry-configurable-fields.model';

export const formEntryConfigurableFieldsState: IFormEntryConfigurableFieldsState = {
  isCheckFormEntryConfigurableFieldsLoading: false,
  isCheckFormEntryConfigurableFieldsLoaded: false,
  isFormEntryConfigurableFieldsLoading: false,
  isFormEntryConfigurableFieldsLoaded: false,
  isCreateFormEntryWithConfigurableFieldsLoading: false,
  isCreateFormEntryWithConfigurableFieldsLoaded: false,
  isUpdateFormEntryConfigurableFieldsLoading: false,
  isUpdateFormEntryConfigurableFieldsLoaded: false,
};

export function formEntryConfigurableFieldsReducer(
  state: IFormEntryConfigurableFieldsState = formEntryConfigurableFieldsState,
  baseAction: Action,
): IFormEntryConfigurableFieldsState {
  const action: Actions.FormEntryConfigurableFieldsActions = baseAction as Actions.FormEntryConfigurableFieldsActions;

  switch (action.type) {
    case Actions.CHECK_HAS_CONFIGURABLE_FIELDS:
      return {
        ...state,
        isCheckFormEntryConfigurableFieldsLoading: true,
        isCheckFormEntryConfigurableFieldsLoaded: false,
      };
    case Actions.CHECK_HAS_CONFIGURABLE_FIELDS_COMPLETED:
      return {
        ...state,
        isCheckFormEntryConfigurableFieldsLoading: false,
        isCheckFormEntryConfigurableFieldsLoaded: true,
      };
    case Actions.UPDATE_FORM_ENTRY_CONFIGURABLE_FIELDS:
      return {
        ...state,
        isUpdateFormEntryConfigurableFieldsLoading: true,
        isUpdateFormEntryConfigurableFieldsLoaded: false,
      };
    case Actions.UPDATE_FORM_ENTRY_CONFIGURABLE_FIELDS_COMPLETED:
      return {
        ...state,
        isUpdateFormEntryConfigurableFieldsLoading: false,
        isUpdateFormEntryConfigurableFieldsLoaded: true,
      };
    case Actions.GET_FORM_ENTRY_CONFIGURABLE_FIELDS_EDIT_DATA:
    case Actions.GET_FORM_ENTRY_CONFIGURABLE_FIELDS_ADD_DATA:
      return {
        ...state,
        isFormEntryConfigurableFieldsLoading: true,
        isFormEntryConfigurableFieldsLoaded: false,
      };
    case Actions.GET_FORM_ENTRY_CONFIGURABLE_FIELDS_EDIT_DATA_COMPLETED:
    case Actions.GET_FORM_ENTRY_CONFIGURABLE_FIELDS_ADD_DATA_COMPLETED:
      return {
        ...state,
        isFormEntryConfigurableFieldsLoading: false,
        isFormEntryConfigurableFieldsLoaded: true,
      };
    case Actions.CREATE_FORM_ENTRY_WITH_CONFIGURABLE_FIELDS:
      return {
        ...state,
        isCreateFormEntryWithConfigurableFieldsLoading: true,
        isCreateFormEntryWithConfigurableFieldsLoaded: false,
      };
    case Actions.CREATE_FORM_ENTRY_WITH_CONFIGURABLE_FIELDS_COMPLETED:
      return {
        ...state,
        isCreateFormEntryWithConfigurableFieldsLoading: false,
        isCreateFormEntryWithConfigurableFieldsLoaded: true,
      };
    default:
      return state;
  }
}
